module.exports = __webpack_public_path__ + "static/media/img_connect03.c391573f.jpg";